<style src="./CloseAccountingCash.scss" lang="scss"></style>
<template>
  <div class="close-accountingcash wrapper wrapper-content animated fadeIn">
    <div class="row">
      <AccountList
        class="col-lg-4 animated fadeInRight"
        @select-account="selectAccounting"
        ref="listRef"
      />
      <div class="col-lg-8">
        <div class="ibox float-e-margins">
          <div class="ibox-content mailbox-content">
            <form v-on:submit.prevent="closeAccountingCahs">
              <h2>Fechamento de caixa</h2>

              <span class="label label-primary pull-right">
                {{ form.totalSystemSalesWallet }}
              </span>

              <div class="space-25"></div>
              <div class="row">
                <div class="form-group col-md-3">
                  <label>Data de abertura</label>
                  <input
                    disabled
                    type="datetime"
                    class="form-control"
                    v-model="form.openedDate"
                  />
                </div>

                <div class="form-group col-md-3">
                  <label>Total do sistema</label>
                  <input
                    disabled
                    type="number"
                    class="form-control"
                    v-model="form.totalSystemSales"
                    step="0.01"
                    value="0.00"
                    placeholder="0.00"
                  />
                </div>
                <div class="form-group col-md-3">
                  <label>Total Dinheiro</label>
                  <input
                    disabled
                    type="number"
                    class="form-control"
                    v-model="form.balanceAmount"
                    step="0.01"
                    value="0.00"
                    placeholder="0.00"
                  />
                </div>
                <div class="form-group col-md-3">
                  <label>Total Cartão</label>
                  <input
                    disabled
                    type="number"
                    class="form-control"
                    v-model="form.cardTotal"
                    step="0.01"
                    value="0.00"
                    placeholder="0.00"
                  />
                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-3">
                  <label>Labels</label>
                  <tags-input
                    v-model="form.labels"
                    placeholder="Insira uma label"
                    :existing-tags="existentLabels"
                    :typeahead="true"
                    only-existing-tags
                  ></tags-input>
                </div>
                <div class="form-group col-md-3">
                  <label>Conta Destino</label>
                  <select class="form-control" v-model="form.transferredTo">
                    <option
                      v-for="(account, index) in accounts"
                      :key="index"
                      :value="account._id"
                    >
                      {{ account.name }}
                    </option>
                  </select>
                </div>
                <div class="form-group col-md-3">
                  <label>Total declarado(Dinheiro)</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model="form.totalDeclared"
                    step="0.01"
                    value="0.00"
                    placeholder="0.00"
                  />
                </div>
                <div class="form-group col-md-3">
                  <label>Total declarado(Cartão)</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model="form.totalDeclaredCard"
                    step="0.01"
                    value="0.00"
                    placeholder="0.00"
                  />
                </div>
              </div>
              <div class="form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-model="allowDifference"
                />
                <label class="form-check-label checkboxlabel"
                  >Permitir diferença</label
                >
              </div>
              <div v-if="allowDifference">
                <Difference
                  ref="CashDiference"
                  title="Dinheiro"
                  :hasValueDiference="hasValueDiference"
                  :valueDiference="valueDiference"
                  :existentLabels="existentLabels"
                />
                <br />
                <Difference
                  ref="CardDiference"
                  title="Cartão"
                  :hasValueDiference="hasValueDiferenceCard"
                  :valueDiference="valueDiferenceCard"
                  :existentLabels="existentLabels"
                />
              </div>
              <br />
              <div class="form-group">
                <label>Observação:</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Digite uma obsrvação caso necessário"
                  v-model="form.description"
                />
              </div>

              <button
                class="btn btn-block btn-primary compose-mail"
                href="mail_compose.html"
                v-if="accountingCashId"
              >
                <i class="fa fa-save"></i>
                Fechar
              </button>
              <div class="divider"></div>
              <br />
              <h3>Retirada</h3>
              <CashMovement
                :cashMovement="cashWithdraw"
                :accountId="accountingCashId"
                @refresh="selectAccounting({ _id: accountingCashId })"
              />
              <br />
              <h3>Reforço de caixa</h3>

              <CashMovement
                :cashMovement="cashReinforcement"
                :transferMode="true"
                :accountId="accountingCashId"
                @refresh="selectAccounting({ _id: accountingCashId })"
              />
              <br />
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask';
import { format } from 'date-fns';

import CashMovement from './components/cash-movement/CashMovement';
import AccountList from './components/account-list/AccountList';
import Difference from './components/difference/Difference';

export default {
  name: 'CloseAccountingCash',
  components: {
    CashMovement,
    AccountList,
    Difference,
  },
  directives: { mask },
  data() {
    return {
      existentLabels: [],
      accounts: [],
      cashWithdraw: [],
      cashReinforcement: [],
      form: {
        openedDate: '',
        totalSystemSales: '',
        totalSystemSalesWallet: '0.00',
        description: '',
        totalDeclared: '',
        totalDeclaredCard: '',
        balanceAmount: '',
        cardTotal: '',
        labels: [],
        transferredTo: '',
      },
      accountingCashId: '',
      allowDifference: true,
    };
  },
  computed: {
    hasValueDiference() {
      return (
        Number(this.form.balanceAmount) !== Number(this.form.totalDeclared)
      );
    },
    hasValueDiferenceCard() {
      return (
        Number(this.form.cardTotal) !== Number(this.form.totalDeclaredCard)
      );
    },
    valueDiference() {
      return this.form.balanceAmount - this.form.totalDeclared;
    },
    valueDiferenceCard() {
      return this.form.cardTotal - this.form.totalDeclaredCard;
    },
    permissionRead() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'close-accounting-cash',
        'READ',
      );
    },
  },

  mounted() {
    this.loadLabels();
    this.listAccounts();
  },
  methods: {
    async loadLabels() {
      const labels = await this.$store.dispatch('LABELS/All');
      const formattedLabels = labels.map((label) => {
        return {
          key: label._id,
          value: label.title,
        };
      });
      this.existentLabels = formattedLabels;
    },
    async listAccounts() {
      try {
        const accounts = await this.$store.dispatch(
          'FINANCIAL-ACCOUNT/ListAll',
        );
        const defaultAccount = accounts.find(
          (acc) => acc.defaultAccount === true,
        );
        if (!(defaultAccount && defaultAccount._id)) {
          return;
        }
        this.form.transferredTo = defaultAccount._id;
        this.accounts = accounts;
      } catch (error) {
        this.$toasted.error('Não foi possível listar as contas');
      }
    },

    async selectAccounting(item) {
      try {
        const payload = {
          accountId: item._id,
        };
        const {
          account,
          totalSystemSales,
          cashReinforcement,
          cashWithdraw,
          balanceAmount,
          cardTotal,
          totalSystemSalesWallet,
        } = await this.$store.dispatch(
          'FINANCIAL-ACCOUNT/GetEmployeeAccountTotal',
          payload,
        );
        this.form.openedDate = format(
          new Date(account.employee.lastClosed || new Date()),
          "dd-MM-yyyy'T'HH:mm:ss",
        );
        const formattedValue = (value) => {
          return (value / 100).toFixed(2);
        };

        this.form.totalSystemSales = formattedValue(totalSystemSales);
        this.form.totalSystemSalesWallet = formattedValue(
          totalSystemSalesWallet,
        );
        this.form.balanceAmount = formattedValue(balanceAmount);
        this.form.cardTotal = formattedValue(cardTotal);

        this.accountingCashId = account._id;

        this.cashWithdraw = cashWithdraw;
        this.cashReinforcement = cashReinforcement;
      } catch (error) {
        this.$toasted.error('Não foi listar as informações do caixa');
      }
    },

    async closeAccountingCahs() {
      try {
        const payload = {
          labels: this.form.labels.map((label) => label.key),
          cashAmount: this.form.totalDeclared * 100,
          cardAmount: this.form.totalDeclaredCard * 100,
          account: this.accountingCashId,
          transferredTo: this.form.transferredTo,
          description: this.form.description
            ? this.form.description
            : undefined,
          type: 'transfer',
          employeeMovementType: 'close',
        };

        if (this.hasValueDiference && this.allowDifference) {
          const { description, labels } = this.$refs.CashDiference.form;
          const differencePayload = {
            description,
            account: this.accountingCashId,
            labels: labels.map((label) => label.key),
            amount: Math.abs(this.valueDiference) * 100,
            type: this.valueDiference > 0 ? 'expense' : 'receive',
            employeeMovementType: 'difference',
            paid: true,
            expiration: new Date(),
          };
          await this.$store.dispatch(
            'FINANCIAL-ACCOUNT/CreateMovement',
            differencePayload,
          );
          this.$refs.CashDiference.form.labels = [];
        }
        if (this.hasValueDiferenceCard && this.allowDifference) {
          const { description, labels } = this.$refs.CardDiference.form;
          const differencePayload = {
            description,
            paymentType: 'debit',
            account: this.accountingCashId,
            labels: labels.map((label) => label.key),
            amount: Math.abs(this.valueDiferenceCard) * 100,
            type: this.valueDiferenceCard > 0 ? 'expense' : 'receive',
            employeeMovementType: 'difference',
            paid: true,
            expiration: new Date(),
          };
          await this.$store.dispatch(
            'FINANCIAL-ACCOUNT/CreateMovement',
            differencePayload,
          );
          this.$refs.CardDiference.form.labels = [];
        }

        await this.$store.dispatch('FINANCIAL-ACCOUNT/CloseMovement', payload);

        this.totalCashWithdraw = '';
        this.totalCashReinforcement = '';
        this.form.openedDate = '';
        this.form.totalSystemSales = '';
        this.form.totalSystemSalesWallet = '0.00';
        this.form.labels = [];
        this.form.description = '';
        this.form.totalDeclared = '';
        this.form.totalDeclaredCard = '';
        this.form.cardTotal = '';
        this.accountingCashId = '';
        this.$refs.listRef.listEmployeeAccount();
        this.$toasted.success('Caixa fechado com sucesso.');
      } catch (error) {
        console.error(error);
        this.$toasted.error('Não foi possível fechar caixa');
      }
    },
  },
};
</script>